import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Modal } from 'react-bootstrap';

//components
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../../TableWidget.js';
import Button from '~/components/CustomButton/CustomButton.jsx';
import WagetypeRefetch from '../../WagetypeRefetch.js';
import AddEditVacationTypeForm from './VacationTypesForm.js';

//elements
import WageTypeDisplay from '~/elements/WageTypeDisplay.js';

//constants
import { WAGE_TYPE_HOURLY_FALLBACK_NOTE, payrollIntegrationOptions } from '~/utils/constants';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

class VacationTypes extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const extendedRules = Object.assign({}, currentEntity.client.data.extendedRules);
        this.integration_details = props.commonStore?.config?.integration_details;
        this.state = {
            vacation_types: extendedRules.vacation_types || [],
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'ab') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'last_updated') || null,
            // vacationCode: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'absenceCode') || [],
            isLoadingWageTypes: false,
            showAllWageTypes: false,
            isEdit: false,
            editData: {}
        }
    }

    toggleModal = (value, data) => {
        this.setState({ isEdit: value, editData: data });
    }

    editVacationType = (index) => {
        const data = this.state.vacation_types[index];
        data.index = index;
        this.toggleModal(true, data);
    }

    onSave = (data) => {
        const { isEdit, editData } = this.state;
        const { commonStore, t } = this.props;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        const vacation_types = [...this.state.vacation_types];
        const fieldsToCheck = [{ field: 'code', name: 'Code' }, { field: 'label', name: 'Label' }];

        for (const { field, name } of fieldsToCheck) {
            const duplicate = vacation_types.find((item, index) => isEdit && editData.index !== undefined && index === editData.index ? false : data[field] == null || data[field] === "" ? false : item[field] === data[field]);
            if (duplicate) return commonStore.addNotification(`${t('Please fill unique value for')} ${t(name)}! ${t("Same value already exists.")}`, null, 'warning');
        }
        if (isEdit && editData.index !== undefined) {
            vacation_types[editData.index] = data;
            delete vacation_types[editData.index].index;
        } else vacation_types.push(data);
        this.setState({ vacation_types: vacation_types }, () => {
            this.props.clientStore.updateVacationTypes(vacation_types);
            this.toggleModal(false, {});
        });
    }

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'ab') || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            // const _vacationCode = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'absenceCode') || [];
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    render() {
        const { vacation_types, wageType, lastUpdated, isLoadingWageTypes, isEdit, showAllWageTypes } = this.state;
        const { t } = this.props;
        const effectiveWageType = showAllWageTypes ? this.props.commonStore.getAllWageTypesCombined() : wageType;
        const isTripletex = this.integration_details?.product === payrollIntegrationOptions.TRIPLETEX;
        const isActivityBased = this.integration_details?.product === payrollIntegrationOptions.XLEDGER || isTripletex;
        const wageTypeColumnLabel = isActivityBased ? 'Activity' : 'Wage Type';
        let headers = ['code', 'Label'],
            metaData = [{ field: 'code', type: 'text', placeholder: 'code', required: true, unique: true },
            { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true }];
        let tableData = vacation_types;
        // Tripletex has no vacation payroll sync at all, so there's no wage type to configure for it.
        if (wageType?.length && !isTripletex) {
            headers = ['code', wageTypeColumnLabel, 'Label'];
            metaData = [{ field: 'code', type: 'text', placeholder: 'code', required: true, unique: true },
            { field: 'wageTypeDisplay', placeholder: wageTypeColumnLabel, html: true },
            { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true }];
            tableData = vacation_types.map(item => ({ ...item, wageTypeDisplay: <WageTypeDisplay wageType={item.payrollWageType} hourlyWageType={item.hourlyPayrollWageType} t={t} /> }));
        }
        // if (this.integration_details?.product === payrollIntegrationOptions.XLEDGER && vacationCode?.length) {
        //     headers.splice(2, 0, 'Vacation Code');
        //     metaData.splice(2, 0, { field: 'vacationCode', type: 'select', placeholder: 'Vacation Code', select: true, data: vacationCode, required: true });
        // }
        return (
            <div>
                <Row className='mt-2'>
                    <Col xs={12} className='d-flex justify-content-end'>
                        <Button wd fill onClick={() => this.toggleModal(true, {})}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" /> {t('Add new')}
                        </Button>
                    </Col>
                </Row>
                {!!wageType.length && !isTripletex &&
                    <WagetypeRefetch
                        t={this.props.t}
                        refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                        lastUpdated={lastUpdated}
                        isLoading={isLoadingWageTypes}
                        dateTimeRules={this.props.commonStore.getDateTimeRules()}
                        extraNote={t(WAGE_TYPE_HOURLY_FALLBACK_NOTE)}
                        showAllWageTypes={showAllWageTypes}
                        onToggleShowAllWageTypes={(value) => this.setState({ showAllWageTypes: value })}
                    />
                }
                <TableWidget
                    headers={headers}
                    metaData={metaData}
                    data={tableData}
                    onChange={_ => { }}
                    // onChange={data => this.props.handleUserDataChange('vacation_types', data)}
                    minRemoveIndex={1}
                    className='mb-100'
                    customFormHandler={this.editVacationType}
                />
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {})}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Vacation')} {t('Type')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {})}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <AddEditVacationTypeForm
                            values={this.state.editData}
                            updateData={this.updateData}
                            onCancel={() => this.toggleModal(false, {})}
                            payroll_wagetypes={isTripletex ? [] : effectiveWageType}
                            // vacationCodes={vacationCode}
                            integrationType={this.integration_details?.product}
                            t={t}
                            onSave={(data) => this.onSave(data)}
                        />
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}
export default inject('clientStore')(applicationRouter(withLocalization(observer(VacationTypes))));